(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bmg-masthead"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('bmg-masthead'))customElements.define('bmg-masthead',class extends HTMLElement{
    connectedCallback(){
      this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;
      const button=this.querySelector('.bmg-mobile-toggle');
      const close=()=>{this.removeAttribute('data-open');button.setAttribute('aria-expanded','false');};
      button.addEventListener('click',()=>{const open=this.toggleAttribute('data-open');button.setAttribute('aria-expanded',String(open));},{signal});
      this.addEventListener('keydown',e=>{if(e.key==='Escape'){this.querySelectorAll('details[open]').forEach(d=>d.open=false);close();button.focus();}},{signal});
      this.querySelectorAll('.bmg-nav details').forEach(d=>d.addEventListener('toggle',()=>{if(d.open)this.querySelectorAll('.bmg-nav details').forEach(other=>{if(other!==d)other.open=false;});},{signal}));
      document.addEventListener('click',e=>{if(!this.contains(e.target))this.querySelectorAll('details[open]').forEach(d=>d.open=false);},{signal});
    }
    disconnectedCallback(){this.controller?.abort();}
  });
  if(!customElements.get('bmg-promo'))customElements.define('bmg-promo',class extends HTMLElement{
    connectedCallback(){
      this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;
      this.items=Array.from(this.querySelectorAll('.bmg-promo__item'));this.index=0;this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.mobile=matchMedia('(max-width:749px)');this.setAttribute('data-ready','');
      this.render=()=>{this.items.forEach((item,i)=>{item.hidden=this.mobile.matches&&i!==this.index;item.style.order=(i-this.index+this.items.length)%this.items.length;});};
      this.move=step=>{this.index=(this.index+step+this.items.length)%this.items.length;this.render();};
      this.querySelector('.bmg-promo__previous').addEventListener('click',()=>this.move(-1),{signal});
      this.querySelector('.bmg-promo__next').addEventListener('click',()=>this.move(1),{signal});
      const pause=this.querySelector('.bmg-promo__pause');
      const update=()=>{pause.setAttribute('aria-pressed',String(this.paused));pause.setAttribute('aria-label',this.paused?pause.dataset.playLabel:pause.dataset.pauseLabel);pause.querySelector('path').setAttribute('d',this.paused?'m8 5 10 7-10 7Z':'M9 5v14M15 5v14');};
      pause.addEventListener('click',()=>{this.paused=!this.paused;update();},{signal});
      this.mobile.addEventListener('change',this.render,{signal});this.render();update();
      clearInterval(this.timer);this.timer=setInterval(()=>{if(!this.paused&&!document.hidden&&!this.matches(':hover')&&!this.contains(document.activeElement)&&this.items.length>1)this.move(1);},Number(this.dataset.speed)||6000);
    }
    disconnectedCallback(){clearInterval(this.timer);this.controller?.abort();}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
